import React, {Component} from 'react'
import PropTypes from 'prop-types'

class BarcodeColumn extends Component {
    render() {
        const {barcode, order, status} = this.props


        return <td className="OrderNumber">
            <span className="d-flex flex-column">
                {barcode && <span className="text-primary">#{barcode}</span>}
                <span className="text-success">{order}</span>
                {status && <span className="text-muted">{status}</span>}
            </span>
        </td>
    }
}

BarcodeColumn.propTypes = {
    barcode: PropTypes.number,
    order: PropTypes.string,
    status: PropTypes.string
}

export default BarcodeColumn